import React, { useState } from "react";
import logo from "../logo.png";
import "../customCSS/InitialPage.css";

const AppConfig = require("application-settings");
const DateInformationVariable = AppConfig.DateInformation;

function InitialPage({ onConfirm }) {
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  return (
    <div className="initial-page">
      <div className="logo-container">
        <img src={logo} alt="Logo" className="logo" />
      </div>
      <div className="header">
        <h2>Staj Başvuru Sistemi</h2>
      </div>
      <div className="content">
        <h3 className="titleWelcome">Hoş geldiniz</h3>
        {/* Staj kontenjanı dolu metni  */}
          {/* <div className="dateInformation">
          <div className="flash-text">{DateInformationVariable}</div>
          </div> */}
        <ul style={{ height: "100%" }}>
          <div className="internshipDetail"></div>
          {AppConfig.informationList.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </div>
      <div className="checkbox-container">
        <input
          type="checkbox"
          id="read-agreement"
          checked={isChecked}
          onChange={handleCheckboxChange}
        />
        <label htmlFor="read-agreement">Yukarıdaki bilgileri okudum...</label>
      </div>
      <button
        className="confirm-button"
        onClick={onConfirm}
        disabled={!isChecked}
      >
        Devam
      </button>
      <footer className="footer">
        <p>© 2024 Siskon Yazılım & Otomasyon v1.0.20</p>
      </footer>
    </div>
  );
}

export default InitialPage;
